<template>
  <div>
    <div class="relative">
      <div class="shadow-sm bg-white border border-gray-50 cursor-zoom-in group">
        <div v-if="this.image_extension == 'pdf'">
           <div class="overflow-hidden" v-if="is_include == 1">
             <embed :src="url+'/storage/'+image_file_path" width="100%" height="400px" />
            <p class="text-center leading-6 -mt-4 px-4 py-1.5 bg-gray-900 bg-opacity-80 text-white text-xs font-medium tracking-wider rounded-md max-w-sm absolute z-50 top-1/2 left-1/2 transform -translate-x-1/2 w-full break-all">
                  {{image_file_name }}  was disabled. <br>
                  <a @click="includeImage()" href="javascript:void(0);" class="underline">Click here</a>
                  to enable it again.
                </p>
                <div class="absolute inset-0 z-40 bg-gray-900 transition-all duration-300 opacity-20"></div>
            <p class="px-3 py-1.5 bg-gray-900 bg-opacity-90 opacity-90 text-white text-xs font-medium tracking-wider inline-flex rounded-full absolute z-50 bottom-3 left-3 break-all">{{image_file_name }}</p>
          </div>
           <div v-else  @click="openImagePreview()">
            <embed :src="url+'/storage/'+image_file_path" width="100%" height="400px" />
            <p class="px-3 py-1.5 bg-gray-900 bg-opacity-90 opacity-90 text-white text-xs font-medium tracking-wider inline-flex rounded-full absolute z-50 bottom-3 left-3 break-all">{{image_file_name }}</p>
          </div>
        </div>

          <div v-else>
             <div class="overflow-hidden" v-if="is_include == 1">
                <img class="block w-full filter blur-sm object-cover" style="height: 400px;" :src="url+'/storage/'+image_file_path">
                <p class="text-center leading-6 -mt-4 px-4 py-1.5 bg-gray-900 bg-opacity-80 text-white text-xs font-medium tracking-wider rounded-md max-w-sm absolute z-50 top-1/2 left-1/2 transform -translate-x-1/2 w-full break-all">
                  {{image_file_name }} image was disabled. <br>
                  <a @click="includeImage()" href="javascript:void(0);" class="underline">Click here</a>
                  to enable it again.
                </p>
                <div class="absolute inset-0 z-40 bg-gray-900 transition-all duration-300 opacity-20"></div>
            </div>

            <div @click="openImagePreview()" v-else>
               <img class="block w-full object-cover" style="height: 400px;" :src="url+'/storage/'+image_file_path">
              <p class="px-3 py-1.5 bg-gray-900 bg-opacity-80 opacity-90 text-white text-xs font-medium tracking-wider inline-flex rounded-full max-w-sm absolute z-50 bottom-3 left-3 break-all">{{image_file_name }}</p>
              <div class="absolute inset-0 z-40 bg-gray-900 transition-all duration-300 opacity-0 group-hover:opacity-20"></div>
            </div>
          </div>

      </div>

      <div class="absolute top-3 right-3 z-50">
        <!-- Show -->
         <button @click="goToImagePath()" title="Show" type="button" class="inline-flex items-center p-1.5 border border-transparent rounded-full shadow text-gray-500 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </button>

        <!-- Edit -->
        <button v-if="!(this.image_extension == 'pdf' || is_include == 1)"  @click="goToEditImagePage()" title="Edit" type="button" class="inline-flex items-center p-1.5 border border-transparent rounded-full shadow text-gray-500 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 ml-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
        </button>

        <!-- Disable -->
        <button v-if="!(is_include == 1)" @click="openDeleteEvidenceModal('Disable')" title="Disable" type="button" class="inline-flex items-center p-1.5 border border-transparent rounded-full shadow text-gray-500 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 ml-2">
         <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
          </svg>
        </button>
      </div>

    </div>

    <ImagePreview v-if="ImagePreviewVisibilty" :image_file_path="image_file_path" :image_file_name="image_file_name" v-on:close_image_preview="closeImage()"></ImagePreview>
    <DeleteEvidence :include_message="IncludeMessageInDisableEnableModal" v-if="deleteEvidenceVisibility" v-on:close-delete-evidence-modal="closeDeleteEvidenceModal" :evidence_image_uid="image_uid"></DeleteEvidence>
</div>
</template>

<script>
import { siteUrl } from '../../config/base';
import ImagePreview from '../Admin/ImagePreview.vue';
import DeleteEvidence from '../Admin/DeleteEvidence.vue';
import ProtestRequestApi from "../../services/api/AdminProtestRequest";

export default {
props :["image_file_path","image_file_name","image_uid","is_include"],
  components: {
    ImagePreview:ImagePreview,
    DeleteEvidence:DeleteEvidence,
  },
  data() {
    return {
      image_extension:'',
      ImagePreviewVisibilty:false,
      deleteEvidenceVisibility:false,
      url:siteUrl,
      IncludeMessageInDisableEnableModal:'',
    };
  },
  created(){
    this.image_extension = this.image_file_path.split(".").pop();
  },
  methods: {
   openImagePreview(){
      this.ImagePreviewVisibilty=true;
   },
   closeImage(){
      this.ImagePreviewVisibilty=false;
   },
   openDeleteEvidenceModal(message){
     this.IncludeMessageInDisableEnableModal = message;
      this.deleteEvidenceVisibility = true;
    },
    closeDeleteEvidenceModal($request){
      this.deleteEvidenceVisibility = false;
      if($request.delete){
        this.$emit('exclude-image-from-evidence',{'delete':$request.delete,'image_uid':$request.image_uid,'comment':$request.comment});
      }
    },
    goToEditImagePage(){
       window.location.href =
          siteUrl + "/admin/"+this.image_uid+"/evidence-update";
    },
    includeImage(){
      ProtestRequestApi.includeEvidence(
          this.image_uid
        ).then((res) => {
          this.$toast.open('Evidence Included');
          this.$emit('evidence-image-include',{'image_uid':this.image_uid});
        }).catch(function(error) {
          throw new Error(error);
        });
    },
    goToImagePath(){
       window.open("/storage/"+this.image_file_path, '_blank');
    },
  }
};
</script>

<style scoped>
</style>
